const Redirect = () => {
  window.location.replace(
    "https://businessbureau0.sharepoint.com/sites/BB-Portal/"
  );
  return null;
};

export default Redirect;
